import { render } from "./ChatPostImageModal.vue?vue&type=template&id=3aa19c33"
import script from "./ChatPostImageModal.vue?vue&type=script&lang=js"
export * from "./ChatPostImageModal.vue?vue&type=script&lang=js"
script.render = render

export default script